import BundlePageContainer from "./components/BundlePageContainer";
import { BundleDataProvider } from "./providers/useBundleDataContext";
import { AttachmentsContextProvider } from "./providers/useAttachmentsContext";

const BundlePage = () => {
  return (
    <BundleDataProvider>
      <AttachmentsContextProvider>
        <BundlePageContainer />
      </AttachmentsContextProvider>
    </BundleDataProvider>
  );
};

export default BundlePage;
